import { Button, Col, Typography } from "@commonlibs";
import { Link } from "react-router-dom";
import { MainRoutes } from "ui/common/router/MainRouter.types";
import useTranslate from "ui/locale/hooks/useTranslate";
import FullLogo from "../../display/FullLogo/FullLogo";

const NotFoundBanner = (): JSX.Element => {
    const translateError = useTranslate("error");
    const translate = useTranslate();

    return (
        <Col alignItems="center" justifyContent="center" gap="2rem" flex={1} css={{ height: "100vh" }}>
            <FullLogo color="primary" size="md" variant="purple" />
            <Typography variant="h1Strong" css={{ fontSize: "11rem", lineHeight: "unset" }}>
                404
            </Typography>
            <Col alignItems="center" gap="0.5rem">
                <Typography variant="h3Strong" textAlign="center">
                    {translateError("notFound")}
                </Typography>
                <Typography variant="body1Regular" textAlign="center">
                    {translateError("content404")}
                </Typography>
            </Col>
            <Link to={MainRoutes.MAIN}>
                <Button>{translate("backToHome")}</Button>
            </Link>
        </Col>
    );
};

export default NotFoundBanner;
